

export const assets = {
    "id": "1fd56b5e-c5cc-49b1-9782-5fab29af29e2",
    "name": "Grey Out Area",
    "type": "polygon",
    "assets": [
      {
        "id": "647b240b-35de-4953-81d3-ebbfb2661fa2",
        "name": "1",
        "levelIndex": 0,
        "coordinates": [
          {
            "x": 53.91703070129053,
            "z": -34.658478864279715,
            "levelIndex": 0
          },
          {
            "x": 40.01504365735046,
            "z": -34.65024202349704,
            "levelIndex": 0
          },
          {
            "x": 40.00403418597851,
            "z": -33.18848464245762,
            "levelIndex": 0
          },
          {
            "x": 51.672664069036195,
            "z": -33.20532749289396,
            "levelIndex": 0
          }
        ],
        "layerType": "polygon",
        "mapped": true
      },
      {
        "id": "e9394288-c884-4ada-9f2b-1591a7a35779",
        "name": "2",
        "levelIndex": 0,
        "coordinates": [
          {
            "x": 12.979119164117579,
            "z": -37.93434249413598,
            "levelIndex": 0
          },
          {
            "x": 13.898625684038059,
            "z": -37.94977814231602,
            "levelIndex": 0
          },
          {
            "x": 13.941958552321447,
            "z": -39.00946393309797,
            "levelIndex": 0
          },
          {
            "x": 19.34679205148663,
            "z": -39.02394392469317,
            "levelIndex": 0
          },
          {
            "x": 19.295564787878376,
            "z": -40.73954284818483,
            "levelIndex": 0
          },
          {
            "x": 18.149767398334205,
            "z": -40.78962987391883,
            "levelIndex": 0
          },
          {
            "x": 18.06077801367165,
            "z": -46.41609972213596,
            "levelIndex": 0
          },
          {
            "x": 19.283909231908904,
            "z": -46.377184822680135,
            "levelIndex": 0
          },
          {
            "x": 19.262639557098048,
            "z": -48.06282682554414,
            "levelIndex": 0
          },
          {
            "x": 12.91505726314941,
            "z": -48.113039034088445,
            "levelIndex": 0
          },
          {
            "x": 12.889221914473907,
            "z": -48.01190345242293,
            "levelIndex": 0
          }
        ],
        "layerType": "polygon",
        "mapped": true
      },
      {
        "id": "2aa09c71-afbf-4fa8-bfd6-6e338866a241",
        "name": "3",
        "levelIndex": 0,
        "coordinates": [
          {
            "x": 43.21779833048842,
            "z": -56.88553233299777,
            "levelIndex": 0
          },
          {
            "x": 43.1407751293566,
            "z": -54.03471286253459,
            "levelIndex": 0
          },
          {
            "x": 43.77738535073303,
            "z": -53.84042012353352,
            "levelIndex": 0
          },
          {
            "x": 43.676978206648315,
            "z": -52.58954498086535,
            "levelIndex": 0
          },
          {
            "x": 38.331868839631504,
            "z": -52.511771753807956,
            "levelIndex": 0
          },
          {
            "x": 38.22757738040576,
            "z": -54.00384888234434,
            "levelIndex": 0
          },
          {
            "x": 30.815305866644287,
            "z": -54.16029468706332,
            "levelIndex": 0
          },
          {
            "x": 30.69244786150516,
            "z": -57.10336338817442,
            "levelIndex": 0
          },
          {
            "x": 39.632540655353026,
            "z": -57.197020040563174,
            "levelIndex": 0
          },
          {
            "x": 40.05773864935662,
            "z": -56.889258662665654,
            "levelIndex": 0
          }
        ],
        "layerType": "polygon",
        "mapped": true
      }
    ]
  }